"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccordionTableWrapper = _interopRequireDefault(require("../../../components/tables/datatable/AccordionTableWrapper"));

var _BrowseFiles = _interopRequireDefault(require("./BrowseFiles"));

var _FileAttachmentMobile = _interopRequireDefault(require("./FileAttachmentMobile"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FileAttachment = function FileAttachment(_ref) {
  var _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? false : _ref$editable,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? null : _ref$cols,
      fileTypes = _ref.fileTypes,
      onFileAdd = _ref.onFileAdd,
      deleteFormatter = _ref.deleteFormatter,
      _ref$files = _ref.files,
      files = _ref$files === void 0 ? [] : _ref$files,
      rest = _objectWithoutProperties(_ref, ["editable", "cols", "fileTypes", "onFileAdd", "deleteFormatter", "files"]);

  var height = 35 + (files ? files.length : 1) * 35;
  return _react["default"].createElement("div", null, editable ? _react["default"].createElement(_BrowseFiles["default"], {
    fileTypes: fileTypes,
    onFileAdd: onFileAdd
  }) : "", _react["default"].createElement("div", null, _react["default"].createElement(_AccordionTableWrapper["default"], _extends({
    id: "file-attachments-table",
    data: files,
    columns: cols,
    accordion: _FileAttachmentMobile["default"],
    height: height,
    customActionButton: deleteFormatter
  }, rest))));
};

FileAttachment.propTypes = {
  /** Is the table in edit mode */
  editable: _propTypes["default"].bool,

  /** What columns should the table display */
  cols: _propTypes["default"].array.isRequired,

  /** What file type(s) should the file upload support */
  fileTypes: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),

  /** Function that fires on addition of new file(s) */
  onFileAdd: _propTypes["default"].func.isRequired,

  /** For mobile, we can pass in a formatter to delete a card (row). For desktop just pass it in via a `formatter` on an item in `cols` */
  deleteFormatter: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].object]),

  /** The array of existing files */
  files: _propTypes["default"].array.isRequired
};
FileAttachment.defaultProps = {
  editable: false,
  cols: [],
  fileTypes: [],
  deleteFormatter: null,
  files: []
};
var _default = FileAttachment;
exports["default"] = _default;